import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { SECTORS } from "@/data/content";

export default function Sectors() {
  const { t } = useLang();

  return (
    <section id="sectors" className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-2xl"
        >
          <p className="flex items-center gap-3 font-mono-brand text-xs tracking-[0.28em] uppercase text-gold-deep mb-5">
            <span className="h-px w-10 bg-gold/70" />
            {t("sectors.eyebrow")}
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-navy-900">
            {t("sectors.title")}
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">{t("sectors.sub")}</p>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-5 auto-rows-[240px] md:auto-rows-[260px]">
          {SECTORS.map((s, i) => (
            <motion.article
              key={s.id}
              data-testid={`sector-card-${s.key}`}
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.12 }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className={`group relative overflow-hidden rounded-3xl border border-gold/25 hover:border-gold/40 transition-colors duration-500 ${s.span}`}
            >
              <img
                src={s.img}
                alt={t(`sectors.${s.key}`)}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover opacity-55 group-hover:opacity-75 group-hover:scale-110 transition-all duration-[900ms] ease-out"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-950 via-navy-950/55 to-navy-950/10" />
              <div
                className="absolute top-5 left-5 h-2.5 w-2.5 rounded-full"
                style={{ background: s.accent, boxShadow: `0 0 14px ${s.accent}` }}
              />
              <div className="absolute bottom-0 left-0 right-0 p-6 lg:p-8">
                <h3 className="font-display text-2xl lg:text-[1.65rem] text-slate-50">{t(`sectors.${s.key}`)}</h3>
                <p className="mt-2 max-w-md text-sm leading-relaxed text-slate-700 opacity-100 lg:opacity-0 lg:translate-y-2 lg:group-hover:opacity-100 lg:group-hover:translate-y-0 transition-all duration-500">
                  {t(`sectors.${s.key}d`)}
                </p>
              </div>
              <span
                className="absolute inset-x-0 bottom-0 h-[3px] scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-700"
                style={{ background: s.accent }}
              />
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
